import { Routes } from '@angular/router';

import { FailedComponent } from './failed/failed.component';
import { HomeComponent } from './home/home.component';
import { ProfileComponent } from './profile/profile.component';

import { CustomerDetailComponent } from './Components/customer-detail/customer-detail.component';
import { FactoryDetailComponent } from './Components/factory-detail/factory-detail.component';
import { ImporteurDetailComponent } from './Components/importeur-detail/importeur-detail.component';
import { LaboratoryDetailComponent } from './Components/laboratory-detail/laboratory-detail.component';

import { ArticleSizeOverviewComponent } from './Components/article-size-overview/article-size-overview.component';
import { ArticleTypeOverviewComponent } from './Components/article-type-overview/article-type-overview.component';
import { ArticleTypeDetailComponent } from './Components/article-type-detail/article-type-detail.component';

import { RequirementsComponent } from './Components/InspectionMasterData/requirements/requirements.component';
import { ProductDetailsComponent } from './Components/InspectionMasterData/productdetails/productdetails.component';
import { PackagingComponent } from './Components/InspectionMasterData/packaging/packaging.component';
import { DocumentsComponent } from './Components/InspectionMasterData/documents/documents.component';
import { IdenticalDesignComponent } from './Components/InspectionMasterData/identicaldesign/identicaldesign.component';
import { InspectionTypesComponent } from './Components/InspectionMasterData/inspection-types/inspection-types.component';

import { LoginComponent } from './Components/login/login.component';

import { InspectionOverviewComponent } from './Components/inspection/inspection-overview/inspection-overview.component';
import { InspectionDetailComponent } from './Components/inspection/inspection-detail/inspection-detail.component';

import { UserDetailComponent } from './Components/user-detail/user-detail.component';
import { UserOverviewComponent } from './Components/user-overview/user-overview.component';
import { MenuManagementComponent } from './Components/menu-management/menu-management.component';
import { InspectionTypeDetailComponent } from './Components/inspection-type-detail/inspection-type-detail.component';

// ✅ NEU: Layouts (Pfad ggf. anpassen!)
import { StandardLayoutComponent } from './layouts/standard-layout/standard-layout.component';
import { DefectsComponent } from './Components/InspectionMasterData/defects/defects.component';
import { routeGuard } from './Shared/Guards/route.guard';
import { InspectionArticleDialogComponent } from './Components/inspection/inspection-article-dialog/inspection-article-dialog.component';

// ✅ NEU: Step-Component für Durchführung (Pfad ggf. anpassen!)

export const routes: Routes = [
  // Start
  { path: '', redirectTo: '/login', pathMatch: 'full' },

  // Login ohne Layout
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [routeGuard]
  },

  // ✅ Durchführung bekommt eigenes Layout (kein Standard-Menü)
  {
    path: 'executeInspection/:id',
    loadComponent: () =>
      import('./layouts/inspection-layout/inspection-layout.component').then(
        (m) => m.InspectionLayoutComponent,
      ),
    canActivate: [routeGuard],
    children: [
      { path: '', redirectTo: 'step/cover-letter', pathMatch: 'full' },

      {
        path: 'step/cover-letter',
        loadComponent: () =>
          import('./Components/executeInspection/cover-letter/cover-letter.component').then(
            (m) => m.CoverLetterComponent,
          ),
      },
      {
        path: 'step/requirements',
        loadComponent: () =>
          import('./Components/executeInspection/execute-requirements/execute-requirements.component').then(
            (m) => m.ExecuteRequirementsComponent,
          ),
      },
      {
        path: 'step/packing',
        loadComponent: () =>
          import('./Components/executeInspection/execute-packing/execute-packing.component').then(
            (m) => m.ExecutePackingComponent,
          ),
      },
      {
        path: 'step/identicalDesign',
        loadComponent: () =>
          import('./Components/executeInspection/execute-identical-design/execute-identical-design.component').then(
            (m) => m.ExecuteIdenticalDesignComponent,
          ),
      },
      {
        path: 'step/documents',
        loadComponent: () =>
          import('./Components/executeInspection/execute-documents/execute-documents.component').then(
            (m) => m.ExecuteDocumentsComponent,
          ),
      },
      {
        path: 'step/productDetails',
        loadComponent: () =>
          import('./Components/executeInspection/execute-product-details/execute-product-details.component').then(
            (m) => m.ExecuteProductDetailsComponent,
          ),
      },
      {
        path: 'step/measurement',
        loadComponent: () =>
          import('./Components/executeInspection/execute-measurement/execute-measurement.component').then(
            (m) => m.ExecuteMeasurementComponent,
          ),
      },
      {
        path: 'step/defects',
        loadComponent: () =>
          import('./Components/executeInspection/execute-defects/execute-defects.component').then(
            (m) => m.ExecuteDefectsComponent,
          ),
      },
      {
        path: 'step/summary',
        loadComponent: () =>
          import('./Components/executeInspection/summary/summary.component').then(
            (m) => m.SummaryComponent,
          ),
      },

      // Fallback
      { path: '**', redirectTo: 'step/cover-letter' }
    ]
  },

  {
    path: '',
    component: StandardLayoutComponent,
    canActivate: [routeGuard],
    children: [
      // Default
      { path: '', redirectTo: 'customers', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },
      { path: 'profile', component: ProfileComponent },

      {
        path: 'customers',
        loadComponent: () =>
          import('./Components/customer-overview/customer-overview.component')
            .then(m => m.CustomerOverviewComponent)
      },
      { path: 'customers/:id', component: CustomerDetailComponent },

      {
        path: 'factories',
        loadComponent: () =>
          import('./Components/factory-overview/factory-overview.component')
            .then(m => m.FactoryOverviewComponent)
      },
      { path: 'factories/:id', component: FactoryDetailComponent },

      {
        path: 'importeurs',
        loadComponent: () =>
          import('./Components/importeur-overview/importeur-overview.component')
            .then(m => m.ImporteurOverviewComponent)
      },
      { path: 'importeurs/:id', component: ImporteurDetailComponent },

      {
        path: 'laboratories',
        loadComponent: () =>
          import('./Components/laboratory-overview/laboratory-overview.component')
            .then(m => m.LaboratoryOverviewComponent)
      },
      { path: 'laboratories/:id', component: LaboratoryDetailComponent },

      { path: 'article-sizes', component: ArticleSizeOverviewComponent },
      { path: 'article-types', component: ArticleTypeOverviewComponent },
      { path: 'article-types/new', component: ArticleTypeDetailComponent },
      { path: 'article-types/:id', component: ArticleTypeDetailComponent },

      { path: 'defects', component: DefectsComponent },
      { path: 'requirements', component: RequirementsComponent },
      { path: 'productDetails', component: ProductDetailsComponent },
      { path: 'packaging', component: PackagingComponent },
      { path: 'documents', component: DocumentsComponent },
      { path: 'identical-design', component: IdenticalDesignComponent },
      { path: 'inspectiontypes', component: InspectionTypesComponent },
      { path: 'inspectionTypeDetail/:id', component: InspectionTypeDetailComponent },

      { path: 'inspection-overview', component: InspectionOverviewComponent },
      {
        path: 'plan-view',
        loadComponent: () =>
          import('./Components/inspection/inspection-plan-view/inspection-plan-view.component')
            .then(m => m.InspectionPlanViewComponent)
      },
      { path: 'inspection-detail/:id', component: InspectionDetailComponent },

      { path: 'admin/user-overview', component: UserOverviewComponent }, // changed
      { path: 'admin/user-detail', component: UserDetailComponent }, // changed
      { path: 'admin/user-detail/:id', component: UserDetailComponent }, // changed
      { path: 'admin/menu-management', component: MenuManagementComponent },
      { path: 'inspection-detail/:inspectionId/article/new', component: InspectionArticleDialogComponent },
      { path: 'inspection-detail/:inspectionId/article/:inspectionArticleId', component: InspectionArticleDialogComponent }
    ]
  },

  { path: '**', redirectTo: 'login' }
];
